export const useCirrusHttpHeaderReader = async (user?: string, sessionToken?: string) => {    
    try {
        const response = await useCirrusReaderHttpRequest(user, sessionToken).sendHeadRequest();
        return {
            mediaType: response.mediaType,
            size: response.contentLength,
            url: '',
        };
    } catch (err) {
        console.error(err);
    }
}